export const noteApiCacheKeys = {
  post: () => ['note_post'] as const,
  put: () => ['note_put'] as const,
  delete: () => ['note_delete'] as const
}
